module.exports = __webpack_public_path__ + "static/media/väggklocka-min.2d7e15f2.png";